import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon";
import { cx } from "../lib/cx";

export type BannerTone = "info" | "success" | "warning" | "danger";
const ICON: Record<BannerTone, IconName> = { info: "info", success: "checkCircle", warning: "alert", danger: "alert" };

export interface BannerProps {
  tone?: BannerTone;
  title?: ReactNode;
  children?: ReactNode;
  action?: ReactNode;
  icon?: IconName;
}

/** danger ใช้ role="alert" เพราะเป็นข้อผิดพลาดที่ต้องแก้ทันที ส่วนอื่นใช้ role="status" */
export function Banner({ tone = "info", title, children, action, icon }: BannerProps) {
  return (
    <div className={cx("banner", tone !== "info" && `banner-${tone}`)} role={tone === "danger" ? "alert" : "status"}>
      <Icon name={icon ?? ICON[tone]} />
      <div className="banner-body">
        {title && <strong>{title}</strong>}
        {children}
        {action && <div style={{ marginTop: 8 }}>{action}</div>}
      </div>
    </div>
  );
}
